module.exports = __webpack_public_path__ + "img/David.b2858dda.jpg";